module.exports = __webpack_public_path__ + "img/22_36.4c8dad0e.png";